import script from "./index.vue?vue&type=script&setup=true&name=layout&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=layout&lang=js"

import "./index.vue?vue&type=style&index=0&id=84029952&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84029952"]])

export default __exports__